import React, { useState } from 'react';

export default function InfoPage04(props) {
  const [comments, setComments] = useState('');

  const handleChange = (event) => {
    setComments(event.target.value);
  }


  return (
    <div>

      <div>
        <br /><br />
        <div className="form-group">
        <br />
          <label htmlFor="comments">Please provide any other comment or feedback.</label>
          <textarea className="form-control" value={comments} onChange={handleChange.bind(this)} rows="4" cols="50" placeholder="your response"/>
        </div>
      </div>

      <br /><br />

      <div className="text-center">
        <button 
          style={{ marginTop: '25px', width: '150px' }} 
          className="btn btn-outline-primary" 
          onClick={(e) => {
            let responses = {
              'id': 'comments',
              'comments': comments,
            }
            setComments('');
          
            props.next(responses)
          }}>Next</button>
      </div>
    </div>
  );

}
